// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu_s42e7PFaJEhnjAWd0Oxk{position:relative;display:inline-block}.Menu_s42e7PFaJEhnjAWd0Oxk .popup_myUCoJSmQ1NSc7AdgzYI{right:-0.7rem;z-index:10000}`, "",{"version":3,"sources":["webpack://./src/components/basics/Menu/Menu.module.scss"],"names":[],"mappings":"AAAA,2BACE,iBAAA,CAEA,oBAAA,CAMA,uDACE,aAAA,CACA,aAAA","sourcesContent":[".Menu {\n  position: relative;\n\n  display: inline-block;\n\n  //> button > span {\n  //  margin: 0 !important;\n  //}\n\n  .popup {\n    right: -0.7rem;\n    z-index: 10000;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Menu": `Menu_s42e7PFaJEhnjAWd0Oxk`,
	"popup": `popup_myUCoJSmQ1NSc7AdgzYI`
};
export default ___CSS_LOADER_EXPORT___;
